const textFieldLogin = {
  password: 'Senha'
};

export default textFieldLogin;
